import { useQuery } from '@tanstack/react-query'
import { api } from './api'

/**
 * Is this member a BETA TESTER? The single capability gate for features that are not finished yet
 * — today the GRID part kind (the "Grid" option when adding an item, and the "convert this table
 * to a grid part" action). Slides parts left the beta with AB#186.
 *
 * Modelled on `useBidProfile`, and an AFFORDANCE for exactly the same reason: the server gates the
 * capability itself (`Services.assertGridBeta` guards `POST /v1/artefacts/parts` with kind 'grid'
 * and every /v1/grid route), so this only exists to avoid showing people controls that will 403.
 *
 * `isResolved` matters more here than in most gates: `/v1/me` is a round trip, and rendering the
 * beta affordance optimistically would flash a control at everyone before hiding it again. Callers
 * treat "not yet resolved" as NOT a tester — the conservative direction, since the cost is a
 * control appearing a moment late rather than one appearing to someone who cannot use it.
 *
 * Reads the SAME `['me']` query key as useBidProfile, so mounting both costs one request.
 */
export function useBetaTester(): { isBeta: boolean; isResolved: boolean } {
  const me = useQuery({ queryKey: ['me'], queryFn: () => api.me(), staleTime: 30_000 })
  return {
    // Optional-chained: a backend older than this flag omits the field entirely, and that must
    // read as "no beta", not throw during render.
    isBeta: me.data?.betaTester ?? false,
    isResolved: Boolean(me.data),
  }
}
